import axios from 'axios';
import { getAuthToken, clearAuthToken } from '../utils/storage';

/** Same resolution as Dockerfile / CI: prefer REACT_APP_API_URL when set at build time. */
export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    'http://127.0.0.1:8000';

/** Build an absolute URL to a path served by the API host (e.g. uploads under /uploads). */
export function apiUrl(path) {
    const rel = String(path ?? '').replace(/^\/+/, '');
    const base = API_BASE_URL.replace(/\/+$/, '');
    return `${base}/${rel}`;
}

const apiClient = axios.create({
    baseURL: API_BASE_URL,
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearAuthToken();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default apiClient;